import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { ConverterService, OccEndpointsService } from "@spartacus/core";
import { Observable } from "rxjs";
import { CustomStoreFinderSearchPage } from "../models/store-finder.model";
import { STORE_FINDER_SEARCH_PAGE_NORMALIZER } from "./converters";
import { CustomStoreFinderAdapter } from "./custom-store-finder.adapter";

@Injectable()
export class CustomOccStoreFinderAdapter implements CustomStoreFinderAdapter {

  constructor(
    protected http: HttpClient,
    protected occEndpointsService: OccEndpointsService,
    protected converterService: ConverterService
  ) { }

  search(): Observable<CustomStoreFinderSearchPage> {
    return this.callOccFindStores().pipe(this.converterService.pipeable(STORE_FINDER_SEARCH_PAGE_NORMALIZER));
  }

  protected callOccFindStores(): Observable<CustomStoreFinderSearchPage> {
    const params = {};

    return this.http.get<CustomStoreFinderSearchPage>(
      this.occEndpointsService.buildUrl('stores', undefined, params)
    );
  }

}
